module.exports = __webpack_public_path__ + "static/media/Einride.2f35590e.jpg";